import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LOGO_URL, NAV_LINKS, GIVING_URL } from "../lib/constants";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-garden/10 bg-cream/85 backdrop-blur-xl" data-testid="site-header">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-full focus:bg-wing focus:px-4 focus:py-2 focus:text-sm focus:text-white"
      >
        Skip to main content
      </a>
      <nav className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-12" aria-label="Main navigation">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo" onClick={() => setOpen(false)}>
          <img src={LOGO_URL} alt="Bee Courageous @ Garden Grub logo" className="h-12 w-12 rounded-full object-cover ring-2 ring-pollen/50" />
          <span className="hidden leading-tight sm:block">
            <span className="block font-serif text-lg font-semibold italic text-wing">Bee Courageous</span>
            <span className="block text-[10px] font-bold uppercase tracking-[0.3em] text-garden">@ Garden Grub</span>
          </span>
        </Link>

        <ul className="hidden items-center gap-1 xl:flex">
          {NAV_LINKS.map((l) => (
            <li key={l.path}>
              <NavLink
                to={l.path}
                data-testid={`nav-${l.path === "/" ? "home" : l.path.slice(1)}`}
                className={({ isActive }) =>
                  `rounded-full px-3 py-2 text-[13px] font-semibold transition-colors duration-200 ${
                    isActive ? "bg-wing-soft text-wing" : "text-charcoal/70 hover:text-wing"
                  }`
                }
              >
                {l.name}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href={GIVING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-pollen hidden !px-6 !py-2.5 sm:inline-flex"
            data-testid="nav-donate-btn"
          >
            Donate
          </a>
          <button
            type="button"
            className="rounded-full p-2 text-charcoal hover:bg-garden-soft xl:hidden"
            aria-expanded={open}
            aria-label={open ? "Close menu" : "Open menu"}
            data-testid="nav-menu-toggle"
            onClick={() => setOpen(!open)}
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-garden/10 bg-cream px-4 pb-6 pt-2 xl:hidden" data-testid="mobile-menu">
          <ul className="flex flex-col">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <NavLink
                  to={l.path}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${l.path === "/" ? "home" : l.path.slice(1)}`}
                  className={`block rounded-xl px-4 py-3 text-sm font-semibold ${
                    pathname === l.path ? "bg-wing-soft text-wing" : "text-charcoal/80"
                  }`}
                >
                  {l.name}
                </NavLink>
              </li>
            ))}
            <li className="mt-3 px-4">
              <a href={GIVING_URL} target="_blank" rel="noopener noreferrer" className="btn-pollen w-full" data-testid="mobile-donate-btn">
                Donate
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};
